import { render, staticRenderFns } from "./Immunities.vue?vue&type=template&id=25e58784&scoped=true"
import script from "./Immunities.vue?vue&type=script&lang=js"
export * from "./Immunities.vue?vue&type=script&lang=js"
import style0 from "./Immunities.vue?vue&type=style&index=0&id=25e58784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e58784",
  null
  
)

export default component.exports